import { NBSP } from '../../constants/symbols';

export const HIW_DATA = [
  {
    text: `Зарегистрируйтесь в${NBSP}сервисе «Зарабатывайте с${NBSP}Циан»`,
  },
  {
    text: `Выберите в${NBSP}личном кабинете программу «Продажа квартиры в${NBSP}Новостройке»`,
  },
  { text: `Найдите, забронируйте и${NBSP}продайте квартиру` },
  {
    text: `Получите вознаграждение за${NBSP}сделку`,
  },
] as const;

export const TYPOGRAPHY = {
  SECTION_TITLE: `Программа для${NBSP}агентов и${NBSP}АН`,
  SECTION_WARNING: `*Подключение к${NBSP}сервису «Продажа квартиры в${NBSP}Новостройке» доступно только юрлицам, ИП${NBSP}и${NBSP}самозанятым`,
};
